(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-pdp-upsell"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ms-product-upsell .swiper').forEach(function (el) {
      new Swiper(el, {
        slidesPerView: 1.25, spaceBetween: 20,
        scrollbar: { el: el.querySelector('.swiper-scrollbar'), draggable: true },
        breakpoints: { 1000: { slidesPerView: 3 }, 900: { slidesPerView: 2.75 },
                       700: { slidesPerView: 2.15, spaceBetween: 20 }, 550: { slidesPerView: 1.75, spaceBetween: 15 } }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-product-main"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded",function(){const section=document.querySelector(".ms-product-main"),mainMedia=section.querySelector(".main-media"),thumbMedia=section.querySelector(".thumb-media"),mainWrapper=mainMedia.querySelector(".swiper-wrapper"),thumbWrapper=thumbMedia.querySelector(".swiper-wrapper"),originalMainHTML=mainWrapper.innerHTML,originalThumbHTML=thumbWrapper.innerHTML,dataEl=document.querySelector(".ms-variant-images-json"),variantImagesMap=dataEl?JSON.parse(dataEl.textContent):null,preloaded=new Set;function preloadImages(images){images.forEach(function(img){preloaded.has(img.src)||(new Image().src=img.src,preloaded.add(img.src)),preloaded.has(img.thumb)||(new Image().src=img.thumb,preloaded.add(img.thumb))})}let swiperMain,swiperThumbs,usingMetaobjectSlides=!1,currentColor=null,currentNonColorOption=null;function scrollThumbsTo(index){if(!swiperThumbs)return;const perView=swiperThumbs.params.slidesPerView,offset=Math.floor(perView/2);swiperThumbs.slideTo(Math.max(0,index-offset))}function initSwipers(){swiperThumbs&&swiperThumbs.destroy(!0,!0),swiperMain&&swiperMain.destroy(!0,!0),swiperThumbs=new Swiper(".ms-product-main .thumb-media .swiper",{slidesPerView:5,spaceBetween:5,watchSlidesProgress:!0,breakpoints:{768:{slidesPerView:6,spaceBetween:10}}}),swiperMain=new Swiper(".ms-product-main .main-media .swiper",{loop:!1,spaceBetween:0,slidesPerView:1,effect:"fade",fadeEffect:{crossFade:!0},navigation:{nextEl:".ms-product-main .main-media .swiper-button-next",prevEl:".ms-product-main .main-media .swiper-button-prev"},thumbs:{swiper:swiperThumbs},on:{slideChange:function(){scrollThumbsTo(this.activeIndex)}}})}function swapSlides(buildMain,buildThumb){mainMedia.style.opacity="0",thumbMedia.style.opacity="0",mainWrapper.innerHTML=buildMain(),thumbWrapper.innerHTML=buildThumb(),initSwipers(),requestAnimationFrame(function(){requestAnimationFrame(function(){mainMedia.style.opacity="",thumbMedia.style.opacity=""})})}function setMetaobjectSlides(images){usingMetaobjectSlides=!0,swapSlides(function(){return images.map(function(img){return'<div class="swiper-slide"><div class="slide-wrapper"><img src="'+img.src+'" alt="'+img.alt+'"></div></div>'}).join("")},function(){return images.map(function(img){return'<div class="swiper-slide"><img src="'+img.thumb+'" alt="'+img.alt+'" loading="lazy"></div>'}).join("")})}function restoreOriginalSlides(){usingMetaobjectSlides=!1,swapSlides(function(){return originalMainHTML},function(){return originalThumbHTML})}function syncSliderToSwatch(swatchId){if(!swatchId)return;const index=Array.from(section.querySelectorAll(".main-media .swiper-slide")).findIndex(s=>s.dataset.swatchId===swatchId);index!==-1&&(swiperMain.slideTo(index),scrollThumbsTo(index))}function navigateToSlideByAlt(color,optionValue){for(var sizePart=optionValue.toLowerCase().replace(/\s+/g,"-"),allColorsAlt="swatch-all-colors-"+sizePart,colorAlt=("swatch-"+color+"-"+optionValue).toLowerCase().replace(/\s+/g,"-"),slides=Array.from(section.querySelectorAll(".main-media .swiper-slide")),index=-1,i=0;i<slides.length;i++){var img=slides[i].querySelector("img");if(img){var alt=img.alt.toLowerCase();if(alt===allColorsAlt){index=i;break}index===-1&&alt===colorAlt&&(index=i)}}var target=index!==-1?index:0;swiperMain.slideTo(target,0),scrollThumbsTo(target)}function onColorChange(optionValue,swatchId){if(variantImagesMap&&variantImagesMap[optionValue]){if(currentColor=optionValue,preloadImages(variantImagesMap[optionValue]),setMetaobjectSlides(variantImagesMap[optionValue]),currentNonColorOption){var navColor=currentColor,navOption=currentNonColorOption;requestAnimationFrame(function(){navigateToSlideByAlt(navColor,navOption)})}}else if(currentColor&&variantImagesMap&&variantImagesMap[currentColor])if(currentNonColorOption=optionValue,usingMetaobjectSlides)navigateToSlideByAlt(currentColor,optionValue);else{setMetaobjectSlides(variantImagesMap[currentColor]);var navColor2=currentColor;requestAnimationFrame(function(){navigateToSlideByAlt(navColor2,optionValue)})}else usingMetaobjectSlides&&restoreOriginalSlides(),syncSliderToSwatch(swatchId)}const urlVariantId=new URLSearchParams(window.location.search).get("variant"),initialOption=section.dataset.initialOption;currentColor=initialOption,currentNonColorOption=section.dataset.initialOption2||null,variantImagesMap&&initialOption&&variantImagesMap[initialOption]&&preloadImages(variantImagesMap[initialOption]),urlVariantId&&variantImagesMap&&initialOption&&variantImagesMap[initialOption]?setMetaobjectSlides(variantImagesMap[initialOption]):initSwipers(),document.addEventListener("change",function(e){e.target.matches('.swatch-input__input, input[type="radio"][data-swatch-id]')&&onColorChange(e.target.value,e.target.dataset.swatchId)})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-video-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ms-video-slider .swiper').forEach(function (el) {
      new Swiper(el, {
        loop: true, slidesPerView: 1.15, spaceBetween: 20,
        breakpoints: { 1024: { slidesPerView: 4 }, 768: { slidesPerView: 2.25 }, 500: { slidesPerView: 1.75 } },
        pagination: { el: el.querySelector('.ms-video-slider .swiper-pagination'), type: 'bullets', clickable: true }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
